<app-header [visibleBurger]="false" [shoppingCart]="true"></app-header>

<!-- <app-carousel-swipe (selectedIndex)="changedTab($event)"></app-carousel-swipe> -->

<mat-tab-group (selectedTabChange)="test($event)">
    <mat-tab [label]="cat" *ngFor="let cat of categories">

        <div class="center" style="margin: 1rem auto !important;">
            <mat-button-toggle-group [(ngModel)]="selector">
                <mat-button-toggle value="packs">Paquetes</mat-button-toggle>
                <mat-button-toggle value="services">Servicios</mat-button-toggle>
            </mat-button-toggle-group>
        </div>
        
        <div class="center">
            <p class="title-text">Categoría {{selectedCategory}}</p>
        </div>

        <app-pricing-plans *ngIf="selector=='packs'"></app-pricing-plans>
        
        <div *ngIf="selector=='services'">
            <!-- <app-carton-dance *ngIf="loading"></app-carton-dance> -->
            <mat-list *ngFor="let product of getProductsByCategory(selectedCategory)" class="flex-column">
                <div class="flex-row service-row" style="justify-content: space-between; padding: 1rem 2rem;">
                    <span style="width: 60%;cursor: pointer;" (click)="descriptionVisible = !descriptionVisible">{{product.product}}</span>
                    <span style="width: 20%;">{{product.price}} EUR</span>
                    <mat-icon  class="add-btn" (click)="addItem(product)">add_circle_outline</mat-icon>
                </div>
                <div *ngIf="descriptionVisible">{{product.description}}</div>
                <mat-divider></mat-divider>
            </mat-list>
        
            <mat-card class="card-bordered" style="margin: 1rem">
                <h4>Más servicios...</h4>
                <div style="padding: 1rem 2rem;">
                    <mat-list *ngFor="let product of getProductsByCategory('Todas')" class="flex-column">
                        <div class="flex-row service-row" style="justify-content: space-between; padding: 1rem 2rem;">
                            <span style="width: 60%;cursor: pointer;" (click)="descriptionVisible = !descriptionVisible">{{product.product}}</span>
                            <span style="width: 20%;">{{product.price}} EUR</span>
                            <mat-icon  class="add-btn" (click)="addItem(product)">add_circle_outline</mat-icon>
                        </div>
                        <div *ngIf="descriptionVisible">{{product.description}}</div>
                        <mat-divider></mat-divider>
                    </mat-list>
                </div>
            </mat-card>
            
        </div></mat-tab>
  </mat-tab-group>

<!-- <app-footer></app-footer> -->